import { extendTailwindMerge } from 'tailwind-merge'

/**
 * Campuzon class merger.
 *
 * The platform defines its own named font-size scale (`text-body`,
 * `text-caption`, `text-h2`…). tailwind-merge cannot tell a size from a
 * colour by name, so out of the box it treats `text-body-sm` as a TEXT
 * COLOUR — and silently drops any `text-white` that came before it. That is
 * what turned filled buttons' labels dark: the variant declared
 * `text-white`, the size class declared `text-body-sm`, and the merge
 * discarded the colour while keeping only a font size.
 *
 * Registering the scale as font-size literals fixes it at the root: size and
 * colour now live in different conflict groups, so both survive the merge.
 */
export const cn = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'caption',
            'body-sm',
            'body',
            'body-lg',
            'h4',
            'h3',
            'h2',
            'h1',
            'display',
          ],
        },
      ],
    },
  },
})
